var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var fontSizeMap = {
    small: '12px',
    regular: '14px',
    large: '16px',
};
var Wrapper = withProps(styled.p)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  line-height: 20px;\n  ", "\n\n    >* {\n      font-size: inherit;\n      font-weight: inherit;\n    }\n"], ["\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n  line-height: 20px;\n  ",
    "\n\n    >* {\n      font-size: inherit;\n      font-weight: inherit;\n    }\n"])), function (_a) {
    var fontSize = _a.fontSize, fontWeight = _a.fontWeight, italic = _a.italic, withMargin = _a.withMargin, inline = _a.inline, ellipsis = _a.ellipsis, theme = _a.theme;
    return "\n    font-size: " + fontSizeMap[fontSize] + ";\n    font-weight: " + theme.datashop.weights[fontWeight ? fontWeight : 'regular'] + ";\n    margin: 0 0 " + (withMargin ? '12px' : 0) + " 0;\n    display: " + (inline ? 'inline-block' : 'block') + ";\n    " + (italic ? 'font-style: italic' : '') + ";\n\n    " + (ellipsis
        ? "\n          overflow: hidden;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n        "
        : '') + "}\n  ";
});
var Text = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Wrapper, __assign({}, props), children));
};
Text.defaultProps = {
    fontSize: 'regular',
    italic: false,
    withMargin: false,
    inline: false,
};
export { fontSizeMap };
export default Text;
var templateObject_1;
//# sourceMappingURL=Text.js.map